// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ label:'科室：',spanRows:12,type:'select',modelValue:'educationalBackground',prefix:'el-icon-require',op:"xlOptions" },
	{ label:'有效状态：',spanRows:12,type:'select',modelValue:'major',prefix:'el-icon-require',im:false,placeholder:'',op:'mjOptions' },
	{ label:'医生姓名：',spanRows:12,type:'input',modelValue:'qualificationNumber',placeholder:'请输入身份证号' },
	{ label:'诊室名称：',spanRows:12,type:'select',modelValue:'practiceDate',im:true,placeholder:'',op:'sexOptions'},
	{ label:'时效：',spanRows:12,type:'date',modelValue:'professionalTitle',placeholder:'',op:'mjOptions'},
	{ label:'无需排班：',spanRows:4,type:'checked',modelValue:'prescriptionRights',im:false,placeholder:'',op:'statusOptions' },
	{ label:'自定义排班：',spanRows:4,type:'checked',modelValue:'anesthesiaAuthorization',im:false,placeholder:'',op:'statusOptions',disabled:true, },
	{ label:'上午开始时间：',spanRows:24,type:'date',modelValue:'surgicalPermission',im:false,placeholder:'',op:'statusOptions',disabled:true, },
	{ label:'下午开始时间：',spanRows:24,type:'date',modelValue:'spiritPermission',im:false,placeholder:'',op:'statusOptions',disabled:true, },
	{ label:'晚班开始时间：',spanRows:24,type:'date',modelValue:'poisonPermission',im:false,placeholder:'',disabled:true,op:'statusOptions' },
]

